import { FC, useRef } from 'react'
import Link from 'next/link'
import cn from 'clsx'
import s from './NavBlocks.module.scss'
import { Text, useUI } from '@components/ui'

import { useGlobalContentContext } from '@context/GlobalContentContext'
import Image from 'next/image'
import { OffRoad, Road, ArrowRight2 } from '@components/icons'
import { useRouter } from 'next/router'

const NavBlocks: FC = () => {
  const { data } = useGlobalContentContext()
  const { closeLoreThreeNavOverlay, closeSidebar } = useUI()
  const { asPath } = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.currentTarget.getAttribute('href') === asPath) {
      e.preventDefault()
      closeLoreThreeNavOverlay()
      closeSidebar()
    }
  }

  if (!data.lorethreeNav) return null
  return (
    <div className={cn(s.grid, s.root)}>
      {data.lorethreeNav.blocks?.map((block, index: number) => (
        <div
          className={s.block}
          key={`block-${index}`}
          data-variant={block.primary_color}
        >
          {/* <Link href={block.links?.[0].href || ''}>
            <a className={s.mobileLink} onClick={handleClick}></a>
          </Link> */}
          <div className={s.titleContainer}>
            <div className={s.icon}>
              <Image
                src={block.icon as string}
                alt={block.title}
                layout="fill"
              />
            </div>

            <Text className={s.blockTitle} variant="pageHeading">
              {block.title}
            </Text>
          </div>
          <div className={s.imageContainer}>
            <div className={cn(s.image, s.shoeImage)}>
              {block.links?.map((link, j) => (
                <Image
                  key={`hover-image-${j}`}
                  src={link.shoe_image as string}
                  alt={link.title}
                  className={s.hoverShoeImage}
                  layout="fill"
                  objectFit="contain"
                  data-index={j}
                />
              ))}
            </div>
            <div className={s.image}>
              {block.primary_color &&
              (block.primary_color as unknown as string) == 'green' ? (
                <OffRoad className={s.overlayIcon} />
              ) : (
                <Road className={s.overlayIcon} />
              )}

              {block.links?.map((link, j) => (
                <Image
                  key={`hover-image-${j}`}
                  src={link.hover_image as string}
                  alt={link.title}
                  className={s.hoverImage}
                  layout="fill"
                  objectFit="cover"
                  data-index={j}
                />
              ))}
            </div>
          </div>

          <nav className={s.navContainer}>
            {block.links?.map((link, index) => (
              <Link href={link.href} key={`link-${index}`}>
                <a
                  className={s.navLink}
                  data-index={index}
                  onClick={handleClick}
                >
                  <div className={s.mobileImageContainer}>
                    <div className={s.mobileImageInner}>
                      <Image
                        src={link.shoe_image as string}
                        alt={link.title}
                        className={s.mobileImage}
                        layout="fill"
                        objectFit="contain"
                      />
                    </div>
                  </div>
                  <div className={s.navLinkContentContainer}>
                    <ArrowRight2 className={s.arrowRight} />
                    <Text
                      className={s.navLinkText}
                      variant="pageHeading"
                      component={'span'}
                    >
                      {link.title}
                    </Text>
                    <Text className={s.navLinkHover} variant="smallText">
                      {link.hover_text}
                    </Text>
                  </div>
                </a>
              </Link>
            ))}
          </nav>
        </div>
      ))}
    </div>
  )
}

export default NavBlocks
